import React, { FC } from 'react';
import { Box, Skeleton } from '@mui/material';
import StyledBox from 'views/rebranded-module/events-module/MotorcycleEventsDetailsView/components/EventInformationSection/EventInformationSection.styles';

const EventInformationSectionSkeleton: FC = () => {
  return (
    <StyledBox>
      {/* About Event Title Skeleton */}
      <Skeleton variant="text" width={200} height={32} sx={{ mb: 2.5 }} />

      {/* Date Info Item Skeleton */}
      <Box className="EInfoItem" mb={1}>
        <Skeleton
          variant="rectangular"
          width={20}
          height={20}
          sx={{ borderRadius: 1 }}
          className="EInfoIcon"
        />
        <Skeleton variant="text" width={200} height={20} />
      </Box>

      {/* Location Info Item Skeleton */}
      <Box className="EInfoItem">
        <Skeleton
          variant="rectangular"
          width={20}
          height={20}
          sx={{ borderRadius: 1 }}
          className="EInfoIcon"
        />
        <Skeleton variant="text" width={250} height={20} />
      </Box>

      {/* Description Skeleton */}
      <Box mt={3}>
        <Skeleton variant="text" width="100%" height={24} />
        <Skeleton variant="text" width="98%" height={24} />
        <Skeleton variant="text" width="95%" height={24} />
        <Skeleton variant="text" width="90%" height={24} />
        <Skeleton variant="text" width="70%" height={24} />
      </Box>
    </StyledBox>
  );
};

export { EventInformationSectionSkeleton };